// PATCH /api/me/notifications: Push-Kategorien und Nachtruhe.
//
// Eigene Datei statt lib/einstellungen.ts, weil der Server das auch als
// eigener Endpunkt fuehrt (api/src/routes/me.ts): "notifications" ist ein
// verschachteltes Objekt, kein weiterer Schluessel im flachen Merge von
// /me/settings.

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "./api.js";

export interface Benachrichtigungseinstellungen {
  sammlung: boolean;
  meilensteine: boolean;
  leaderboard: boolean;
  system: boolean;
  admin: boolean;
  quietStart: string | null;
  quietEnd: string | null;
}

/** Deckungsgleich mit api/src/lib/benachrichtigungEinstellungen.ts. */
export const STANDARD_BENACHRICHTIGUNGEN: Benachrichtigungseinstellungen = {
  sammlung: true,
  meilensteine: false,
  leaderboard: false,
  system: true,
  admin: true,
  quietStart: null,
  quietEnd: null,
};

export function useBenachrichtigungenSpeichern() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (patch: Partial<Benachrichtigungseinstellungen>) =>
      api<{ notifications: Benachrichtigungseinstellungen }>("/me/notifications", { method: "PATCH", body: patch }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["me"] });
    },
  });
}
